module.exports = __webpack_public_path__ + "static/media/connection-offline.d1370502.svg";